<template>
  <div>
    {{ msg }}
  </div>
</template>

<script>
export default {
  name: 'Docs',
  props: ['urlParams'],
  created () {
    console.log('DOCS CREATED', this.urlParams)
  },
  data () {
    return {
      msg: 'Docs'
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Docs.vue